import api from './axios';

export const paymentAPI = {
  // Get athlete details for payment
  getAthleteForPayment: async (athleteId) => {
    const response = await api.get(`/payment/${athleteId}`);
    return response.data;
  },

  // Select event for athlete
  selectEvent: async (athleteId, eventId) => {
    const response = await api.post('/payment/select-event', { athleteId, eventId });
    return response.data;
  },

  // Create Razorpay order
  createOrder: async (athleteId) => {
    const response = await api.post('/payment/create-order', { athleteId });
    return response.data;
  },

  // Verify payment
  verifyPayment: async (paymentData) => {
    const response = await api.post('/payment/verify', paymentData);
    return response.data;
  },

  // Get payment status
  getPaymentStatus: async (athleteId) => {
    const response = await api.get(`/payment/status/${athleteId}`);
    return response.data;
  },

  // Download invoice
  downloadInvoice: async (athleteId) => {
    const response = await api.get(`/payment/invoice/${athleteId}`, {

    });
    return response.data;
  },
};
